import React from "react"
import {Dispatch} from "redux"
import {connect} from "react-redux"

// Actions
import {
    closeSingleRecordWSConnection,
    openSingleRecordWSConnectionAsync,
    openAvailableRecordsWSConnectionAsync,
    closeAvailableRecordsWSConnection
} from "../store/actions"

/**
 * @param dispatch
 */
const mapDispatchToProps = (dispatch: Dispatch) => ({
    openSingleRecordWSConnection: () => dispatch(openSingleRecordWSConnectionAsync.request()),
    closeSingleRecordWSConnection: (code?: number, reason?: string) => dispatch(closeSingleRecordWSConnection({
        code,
        reason
    })),
    openAvailableRecordsWSConnectionAsync: () => dispatch(openAvailableRecordsWSConnectionAsync.request()),
    closeAvailableRecordsWSConnection: (code?: number, reason?: string) => dispatch(closeAvailableRecordsWSConnection({
        code,
        reason
    })),
});

/**
 * @param BaseComponent
 */
export default (BaseComponent: React.ComponentType<any>) => connect(null, mapDispatchToProps)(BaseComponent)

export type WithWSConnectionProps = {
    openSingleRecordWSConnection(): void
    closeSingleRecordWSConnection(code?: number, reason?: string): void
    openAvailableRecordsWSConnectionAsync(): void
    closeAvailableRecordsWSConnection(code?: number, reason?: string): void
}
